import { Link } from "react-router-dom";

export const LogoMark = ({ size = 34, className = "" }) => (
  <img src="/images/bm-logo.png" alt="Backer Marathon logo" width={size} height={size}
    data-testid="logo-mark" className={`rounded-full ${className}`} />
);

export const Logo = () => (
  <Link to="/" data-testid="logo-home-link" className="flex items-center gap-3">
    <LogoMark size={48} />
    <span className="flex flex-col leading-none">
      <span className="font-body font-bold tracking-tight text-navy text-sm">BACKER MARATHON</span>
      <span className="font-mono text-[9px] tracking-[0.25em] text-ember mt-1">WEBSITE REDESIGN PROPOSAL</span>
    </span>
  </Link>
);
